import NewsDetail from './components';

export default NewsDetail;
